import Avatar from '@/components/Avatar'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import * as styles from './style'

export interface Props {
  imageUrl?: string
  title?: string
  subtitle?: string
  quoteContent?: string
  attention?: boolean
}

const QuoteCard = ({ title, subtitle, imageUrl, quoteContent, attention = false }: Props): JSX.Element => (
  <Stack className={styles.root}>
    {quoteContent && (
      <Text tag="p" className="fc-dark" size="xs" weight="sm">
        &ldquo;{quoteContent}&rdquo;
      </Text>
    )}
    <Stack className={styles.profile}>
      {imageUrl && <Avatar className={styles.avatar} src={imageUrl} size="md" attention={attention} />}
      <Stack className={styles.info}>
        {title && (
          <Text tag="strong" className="fc-dark" weight="lg" size="sm">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text tag="span" className="fc-dark" size="xs" weight="sm">
            {subtitle}
          </Text>
        )}
      </Stack>
    </Stack>
  </Stack>
)
export default QuoteCard
